export enum KnowledgeBaseContentType {
  TEMPLATE = 'template',
  FIELD_DEFINITION = 'field_definition',
  LEGAL_PRECEDENT = 'legal_precedent',
  COMPANY_DESCRIPTION = 'company_description',
  JOB_DESCRIPTION = 'job_description',
  EXPERT_LETTER_TEMPLATE = 'expert_letter_template',
  COVER_LETTER_TEMPLATE = 'cover_letter_template',
  OTHER = 'other',
}

export const VISA_TYPES = [
  'O1-A',
  'O1-B',
  'EB1-A',
  'EB1-B',
  'EB1-C',
  'EB2-NIW',
  'E2',
  'L1-A',
  'L1-B',
] as const;

export type VisaType = typeof VISA_TYPES[number];

export const CONTENT_TYPE_LABELS: Record<KnowledgeBaseContentType, string> = {
  [KnowledgeBaseContentType.TEMPLATE]: 'Template',
  [KnowledgeBaseContentType.FIELD_DEFINITION]: 'Field Definition',
  [KnowledgeBaseContentType.LEGAL_PRECEDENT]: 'Legal Precedent',
  [KnowledgeBaseContentType.COMPANY_DESCRIPTION]: 'Company Description',
  [KnowledgeBaseContentType.JOB_DESCRIPTION]: 'Job Description',
  [KnowledgeBaseContentType.EXPERT_LETTER_TEMPLATE]: 'Expert Letter Template',
  [KnowledgeBaseContentType.COVER_LETTER_TEMPLATE]: 'Cover Letter Template',
  [KnowledgeBaseContentType.OTHER]: 'Other',
};

export const CONTENT_TYPE_COLORS: Record<KnowledgeBaseContentType, string> = {
  [KnowledgeBaseContentType.TEMPLATE]: 'bg-purple-100 text-purple-800',
  [KnowledgeBaseContentType.FIELD_DEFINITION]: 'bg-blue-100 text-blue-800',
  [KnowledgeBaseContentType.LEGAL_PRECEDENT]: 'bg-red-100 text-red-800',
  [KnowledgeBaseContentType.COMPANY_DESCRIPTION]: 'bg-green-100 text-green-800',
  [KnowledgeBaseContentType.JOB_DESCRIPTION]: 'bg-yellow-100 text-yellow-800',
  [KnowledgeBaseContentType.EXPERT_LETTER_TEMPLATE]: 'bg-indigo-100 text-indigo-800',
  [KnowledgeBaseContentType.COVER_LETTER_TEMPLATE]: 'bg-pink-100 text-pink-800',
  [KnowledgeBaseContentType.OTHER]: 'bg-gray-100 text-gray-800',
};
